import { render, staticRenderFns } from "./Game_CoinProduct.vue?vue&type=template&id=df7f6402&scoped=true&"
import script from "./Game_CoinProduct.vue?vue&type=script&lang=js&"
export * from "./Game_CoinProduct.vue?vue&type=script&lang=js&"
import style0 from "./Game_CoinProduct.vue?vue&type=style&index=0&id=df7f6402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7f6402",
  null
  
)

export default component.exports